"use strict";

var _interopRequireWildcard = require("@babel/runtime-corejs2/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _construct = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/reflect/construct"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/possibleConstructorReturn"));

var _get2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/get"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _ArrayHelper = require("../../../helpers/ArrayHelper");

var _Spinner = _interopRequireDefault(require("../Spinner/Spinner"));

var _StringHelper = _interopRequireDefault(require("../../../helpers/StringHelper"));

var _QuizRoundHeader = _interopRequireDefault(require("./QuizRoundHeader.scss"));

var _DeviceInfoHelper = _interopRequireDefault(require("../../../helpers/DeviceInfoHelper"));

var _server = _interopRequireDefault(require("react-dom/server"));

var _Done = _interopRequireDefault(require("@material-ui/icons/Done"));

var _Close = _interopRequireDefault(require("@material-ui/icons/Close"));

var _DataStoreComponent2 = _interopRequireDefault(require("../DataStoreComponent/DataStoreComponent2"));

var _DataStore = _interopRequireWildcard(require("../../../KESI2/Stores/DataStore2"));

var _ThemeStore = _interopRequireDefault(require("../ThemeStore/ThemeStore2"));

var _QuizRoundStyle = require("./styles/QuizRoundStyle");

var _Question = require("./Question2");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = (0, _construct["default"])(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !_construct["default"]) return false; if (_construct["default"].sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call((0, _construct["default"])(Date, [], function () {})); return true; } catch (e) { return false; } }

var QuizRoundHeader = /*#__PURE__*/function (_DataStoreComponent) {
  (0, _inherits2["default"])(QuizRoundHeader, _DataStoreComponent);

  var _super = _createSuper(QuizRoundHeader);

  function QuizRoundHeader(props) {
    var _thisSuper, _this;

    (0, _classCallCheck2["default"])(this, QuizRoundHeader);
    _this = _super.call(this, props);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "getCurrentQuestion", function () {
      if (_this.props.isSinglePlayer) {
        var questions = _this.props.questions.current;
        var currentIndex = _DataStore["default"].getElementByPathImmediately(_DataStore.DATA_STORE_PATHS.QD_SINGLE_PLAYER_QUESTION_INDEX) || 0;
        console.log('getCurrentQuestion', questions[currentIndex]);
        return questions[currentIndex];
      } else {
        var _questions = _this.props.questions;

        var currentIndexObj = _DataStore["default"].getElementByPathImmediately(_DataStore.DATA_STORE_PATHS.QD_CURRENT_QUESTION_STATUS);

        var _currentIndex = currentIndexObj && currentIndexObj.number ? currentIndexObj.number : 0;

        console.log('getCurrentQuestion', _currentIndex);
        return _questions[_currentIndex];
      }
    });
    _this.state = {};
    (0, _get2["default"])((_thisSuper = (0, _assertThisInitialized2["default"])(_this), (0, _getPrototypeOf2["default"])(QuizRoundHeader.prototype)), "addStoresAndKeys", _thisSuper).call(_thisSuper, [{
      store: _ThemeStore["default"],
      keys: ['currentTheme', 'quiz']
    }]);
    return _this;
  }

  (0, _createClass2["default"])(QuizRoundHeader, [{
    key: "renderForQuestion",
    value: function renderForQuestion(questionIndex) {
      var dynamicStyles = (0, _QuizRoundStyle.getHeaderStyles)(this.state);
      var number = null;
      var backgroundColorOuterDiv;
      var classNamesInnerDiv;
      var styleInnerDiv = {};
      var icon = null;
      var style = {
        fontSize: '20px',
        position: 'absolute',
        left: '50%',
        top: '50%',
        transform: 'translate(-50%, -50%)'
      };

      var checkIcon = /*#__PURE__*/_react["default"].createElement(_Done["default"], {
        style: style
      });

      var wrongIcon = /*#__PURE__*/_react["default"].createElement(_Close["default"], {
        style: style
      });

      var answerArray = this.props.isSinglePlayer ? this.props.answerResults.current : this.props.userState;

      var hideFeedbackByGroup = _DataStore["default"].getElementByPathImmediately(_DataStore.DATA_STORE_PATHS.QD_GROUP_HIDE_FEEDBACK);

      var question = this.props.isSinglePlayer ? this.props.questions.current[questionIndex] : this.props.questions[questionIndex];
      console.log('QuizRoundHeader', answerArray);

      if (answerArray[questionIndex]) {
        // already answered
        backgroundColorOuterDiv = dynamicStyles.answerStatusStyle.second;

        if (answerArray[questionIndex].isUnanswered) {
          backgroundColorOuterDiv = dynamicStyles.answerStatusStyle.main;
          classNamesInnerDiv = _QuizRoundHeader["default"].answerStatusInner;
          number = questionIndex + 1;
        } else {
          if (!hideFeedbackByGroup) {
            if (question.type !== _Question.QUESTION_TYPES.SE && answerArray[questionIndex].score >= 1 || question.type === _Question.QUESTION_TYPES.SE && answerArray[questionIndex].score === question.score || answerArray[questionIndex] && answerArray[questionIndex].isCorrect) {
              // correctly answered
              classNamesInnerDiv = _QuizRoundHeader["default"].answerStatusFeedback;
              icon = checkIcon;
              styleInnerDiv = {
                color: dynamicStyles.correctStyle.backgroundColor,
                backgroundColor: dynamicStyles.answerStatusStyle.main
              };
            } else {
              // wrongly answered
              classNamesInnerDiv = _QuizRoundHeader["default"].answerStatusFeedback;
              icon = wrongIcon;
              styleInnerDiv = {
                color: dynamicStyles.wrongStyle.backgroundColor,
                backgroundColor: dynamicStyles.answerStatusStyle.second
              };
            }
          } else {
            backgroundColorOuterDiv = dynamicStyles.answerStatusStyle.second;
            classNamesInnerDiv = _QuizRoundHeader["default"].answerStatusInner;
            number = questionIndex + 1;
          }
        }
      } else if (questionIndex === 0 || answerArray[questionIndex - 1] && !answerArray[questionIndex - 1].isUnanswered && !answerArray[questionIndex]) {
        // current question
        backgroundColorOuterDiv = dynamicStyles.answerStatusStyle.main;
        classNamesInnerDiv = _QuizRoundHeader["default"].answerStatusInner;
        number = questionIndex + 1;
      } else {
        // future question
        backgroundColorOuterDiv = dynamicStyles.answerStatusStyle.second;
        classNamesInnerDiv = _QuizRoundHeader["default"].answerStatusInner;
        number = questionIndex + 1;
      }

      var styleOuterDiv = {
        color: dynamicStyles.answerStatusStyle.third,
        backgroundColor: backgroundColorOuterDiv
      };
      return /*#__PURE__*/_react["default"].createElement("div", {
        key: "question_".concat(questionIndex),
        className: "".concat(_QuizRoundHeader["default"].answerStatus, " ").concat(_QuizRoundHeader["default"].answerStatusContainer),
        style: styleOuterDiv
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: classNamesInnerDiv,
        style: styleInnerDiv
      }, icon, number));
    }
  }, {
    key: "renderSequenceBackgrounds",
    value: function renderSequenceBackgrounds() {
      var _this2 = this;

      var currentSequenceId = null;
      var currentSequenceBegin = null;
      var questions = this.props.isSinglePlayer ? this.props.questions.current : this.props.questions;
      var sequenceBackgrounds = questions.reduce(function (acc, question, index) {
        // if (index === 0 || index === 1) {
        //   question.sequence = '_sequence_'
        // }
        // if (index === 2 || index === 3) {
        //   question.sequence = '_sequence2_'
        // }
        var returnValue = acc;

        if (currentSequenceId !== question.sequence) {
          if (currentSequenceId) {
            returnValue.push( /*#__PURE__*/_react["default"].createElement("div", {
              key: question.sequence,
              className: _QuizRoundHeader["default"].sequenceOuter
            }, /*#__PURE__*/_react["default"].createElement("div", {
              className: _QuizRoundHeader["default"].sequence,
              style: {
                width: (index - currentSequenceBegin) * 23,
                right: (_this2.props.questions.length - index) * 23 // actually (length - 1) - (index - 1)

              }
            })));
            currentSequenceId = null;
            currentSequenceBegin = null;
          }

          if (question.sequence) {
            currentSequenceId = question.sequence;
            currentSequenceBegin = index;
          }
        } // add block if this was the last question and there is still an open block left


        if (index === _this2.props.questions.length - 1 && currentSequenceBegin !== null) {
          returnValue.push( /*#__PURE__*/_react["default"].createElement("div", {
            key: question.sequence,
            className: _QuizRoundHeader["default"].sequenceOuter
          }, /*#__PURE__*/_react["default"].createElement("div", {
            className: _QuizRoundHeader["default"].sequence,
            style: {
              width: (index - currentSequenceBegin + 1) * 23,
              right: 0
            }
          })));
        }

        return returnValue;
      }, []);
      return sequenceBackgrounds;
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      var dynamicStyles = (0, _QuizRoundStyle.getHeaderStyles)(this.state);

      if (!this.props.userState) {
        return /*#__PURE__*/_react["default"].createElement(_Spinner["default"], null);
      }

      var questionStatuses = (0, _ArrayHelper.IndexArray)(this.props.questionsPerRound).map(function (index) {
        return _this3.renderForQuestion(index);
      });
      var sequences = this.renderSequenceBackgrounds();
      var classNames = _QuizRoundHeader["default"].opponent;

      if (_DeviceInfoHelper["default"].isBrowser()) {
        classNames += ' ' + _QuizRoundHeader["default"].browser;
      }

      var question = this.getCurrentQuestion();
      var points = question && question.score ? /*#__PURE__*/_react["default"].createElement("div", {
        className: this.props.isSinglePlayer ? _QuizRoundHeader["default"].singlePlayerPoints : _QuizRoundHeader["default"].points,
        style: dynamicStyles.textStyle
      }, question.score > 1 ? "".concat(question.score, " Punkte") : "".concat(question.score, " Punkt")) : null;
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: _QuizRoundHeader["default"].container
      }, this.props.isSinglePlayer ? null : /*#__PURE__*/_react["default"].createElement("span", {
        className: _QuizRoundHeader["default"].names
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: classNames,
        style: dynamicStyles.textStyle
      }, "vs.\xA0", this.props.opponent.nickname)), points, sequences, /*#__PURE__*/_react["default"].createElement("div", {
        className: this.props.isSinglePlayer ? _QuizRoundHeader["default"].singlePlayerAnswers : _QuizRoundHeader["default"].answers
      }, questionStatuses));
    }
  }]);
  return QuizRoundHeader;
}(_DataStoreComponent2["default"]); // noinspection Eslint


QuizRoundHeader.propTypes = {
  userState: _propTypes["default"].array.isRequired,
  // eslint-disable-line
  questions: _propTypes["default"].array.isRequired,
  opponent: _propTypes["default"].object.isRequired,
  // eslint-disable-line
  questionsPerRound: _propTypes["default"].number.isRequired,
  user: _propTypes["default"].object,
  // eslint-disable-line
  styles: _propTypes["default"].object.isRequired,
  // eslint-disable-line,
  answers: _propTypes["default"].array,
  answerResults: _propTypes["default"].array,
  isSinglePlayer: _propTypes["default"].bool
};
QuizRoundHeader.defaultProps = {
  isSinglePlayer: false
};
var _default = QuizRoundHeader;
exports["default"] = _default;